import { useState, useMemo, createElement } from 'react';
import { MenuContext } from './Context.js';
import { Root } from '@radix-ui/react-dropdown-menu';
import { Content } from './components/Content.js';
import { Item } from './components/Item.js';
import { Link } from './components/Link.js';
import { Trigger } from './components/Trigger.js';
import { Checkbox } from './components/Checkbox.js';
import { RadioGroup } from './components/RadioGroup.js';
import { Separator } from './components/Separator.js';
import { Header } from './components/Header.js';

const Menu = externalProps => {
  const {
    children,
    trigger,
    ...props
  } = externalProps;
  const [open, setOpen] = useState(false);
  const [indented, setIndented] = useState(false);
  const [minWidth, setMinWidth] = useState(undefined);
  const context = useMemo(() => ({
    indented,
    registerIndentation: () => setIndented(true),
    minWidth,
    setMinWidth: width => setMinWidth(width),
    close: () => setOpen(false)
  }), [indented, minWidth]);
  return createElement(MenuContext.Provider, {
    value: context
  }, createElement(Root, Object.assign({}, props, {
    modal: false,
    open: open,
    onOpenChange: setOpen
  }), trigger && createElement(Trigger, null, trigger), children));
};
Menu.Trigger = Trigger;
Menu.Content = Content;
Menu.Item = Item;
Menu.Link = Link;
Menu.Checkbox = Checkbox;
Menu.Separator = Separator;
Menu.Header = Header;
Menu.RadioGroup = RadioGroup;

export { Menu };
//# sourceMappingURL=Menu.js.map
